export const ignoredErrors: string[] = [
  'token.invalid',
];
